import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(() => {
    try { return JSON.parse(localStorage.getItem('iassets_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('iassets_token');
    if (token) {
      authAPI.me()
        .then(r => setUser(r.data))
        .catch(() => { localStorage.removeItem('iassets_token'); localStorage.removeItem('iassets_user'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('iassets_token', data.token);
    localStorage.setItem('iassets_user',  JSON.stringify(data.user));
    setUser(data.user);
    window.dispatchEvent(new Event('iassets_auth_change')); // ← ADD
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await authAPI.logout(); } catch {}
    localStorage.removeItem('iassets_token');
    localStorage.removeItem('iassets_user');
    setUser(null);
    window.dispatchEvent(new Event('iassets_auth_change')); // ← ADD
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
